/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import {
    ConfusionRecord,
    LabelOrDocumentDistributionPerDataSet
} from 'src/customText/core/services/modelGuidance/customTextModelGuidanceSwaggers';
import { CapabilityType } from 'src/languageStudio/core/types';

export type Distribution = {
    labelName: string;
    labelsDistribution?: LabelOrDocumentDistributionPerDataSet;
    examplesDistribution?: LabelOrDocumentDistributionPerDataSet;
    documentsDistribution?: LabelOrDocumentDistributionPerDataSet;
};

export class ModelGuidanceStore {
    public modelName: string;

    public missingLabels: string[];

    public testMinimumThreshold: number;

    public trainMinimumThreshold: number;

    public insufficientExamples: string[];

    public testUnbalancedLabels: string[];

    public trainUnbalancedLabels: string[];

    public confusionLabels: ConfusionRecord[];

    public projectKind: CapabilityType;

    public unbalancedDataDistribution: boolean;

    public labelsDistribution: Distribution[];

    public minimumNumberOfRequiredExamples: number;

    public modelDistributionPerDataSet: LabelOrDocumentDistributionPerDataSet;

    constructor(data: Partial<ModelGuidanceStore>) {
        this.modelName = data.modelName;
        this.projectKind = data.projectKind;
        this.missingLabels = data.missingLabels;
        this.confusionLabels = data.confusionLabels;
        this.labelsDistribution = data.labelsDistribution;
        this.insufficientExamples = data.insufficientExamples;
        this.testUnbalancedLabels = data.testUnbalancedLabels;
        this.testMinimumThreshold = data.testMinimumThreshold;
        this.trainMinimumThreshold = data.trainMinimumThreshold;
        this.trainUnbalancedLabels = data.trainUnbalancedLabels;
        this.unbalancedDataDistribution = data.unbalancedDataDistribution;
        this.modelDistributionPerDataSet = data.modelDistributionPerDataSet;
        this.minimumNumberOfRequiredExamples = data.minimumNumberOfRequiredExamples;
    }
}
